<template>
  <div class="expandableList">
    <div class="expandableList__card__channels__header">
      <div class="expandableList__card__channels__header__title">
        <span class="strong" @click="goToDetail(item, list)">{{item.placement}} {{this.media_type(item, list.property_type)}}</span>
      </div>
      <button class="btn-regular secondary" @click.stop="toggleSave(list, item)">
        <div class="saved_button">
          <div v-if="item.saved" class="saved_button__is_saved">
            <i class="icon-check icon"></i>
            <span> Saved </span>
          </div>
          <div v-else class="saved_button__not_saved">
            <i class="icon-add icon"></i>
            <span class="label">Save</span>
          </div>
        </div>
      </button>
    </div>
    <div class="expandableList__card__channels__content">
      <div class="expandableList__card__channels__content__left">
        <div class="expandableList__card__channels__content__left__place-image">
          <div v-if="item.photo" class="action">
            <img :src="item.photo" alt="">
            <div class="action__viewphoto" v-if="viewPhoto">
              <button class="btn-regular secondary action__viewphoto__save" @click.stop="previewImage(item, list)">
                View Photos
              </button>
            </div>
          </div>
          <img v-else :src="`/img/notfound/img-placeholder_landscape.jpg`">
        </div>
        <div class="expandableList__card__channels__content__left__info">
          <span> {{item.description}} </span>
          <!-- <div class="expandableList__card__channels__content__left__info__left">
            <span> Total screens <b>3 screens</b> </span>
            <span> Screen size <b>42 inch</b> </span>
            <span> Orientation <b>Landsacpe</b> </span>
          </div>
          <div class="expandableList__card__channels__content__left__info__right">
            <span> Resolution <b>1080p</b> </span>
            <span> Playback <b>80/day</b> </span>
          </div> -->
        </div>
      </div>
      <div class="expandableList__card__channels__content__right">
        <div class="expandableList__card__channels__content__right__price">
          <span v-if="item.period" class="small-font">Price per {{item.period}}</span>
          <span v-else class="small-font">Price per day</span>
          <span class="regular-font color-pink strong">{{item.price | formatMoney}}</span>
          <span v-if="item.include_tax" class="small-font color-grey">Inclusive of Taxes</span>
          <span v-else class="small-font color-grey">Exclusive of Taxes</span>
        </div>
        <div class="expandableList__card__channels__content__right__button">
          <button v-if="item.isAdded" class="btn-regular secondary" @click="removeFromCampaign(item, list)" >{{ removeButton }}</button>
          <button v-else class="primary btn-regular" @click="addToCampaign(list, item)">{{ addButton }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-expandable-level2',
  components: {

  },
  props: {
    item: {
      required: true
    },
    viewPhoto: {
      required: false,
      default: false
    },
    addButton: {
      required: false,
      default: 'Add To Order'
    },
    removeButton: {
      required: false,
      default: 'Remove Order'
    },
    list:{
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
      isOpen: [],
      isLoading: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    // this.setIsOpen()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    previewImage(item, list){
      this.$emit('previewImage', item, list)
    },
    toggleSave(list, item) {
      this.$emit('toggleSave',list, item)
    },
    addToCampaign(list, item) {
      this.$emit('addToCampaign',list, item)
    },
    removeFromCampaign(item, list){
      this.$emit('removeFromCampaign', item, list)
    },
    toggleOpen(index) {
      this.$set(this.isOpen, index, !this.isOpen[index])
    },
    goToDetail(item, list) {
      this.$emit('goToDetail', item, list)
    },
    media_type(item, type){
      if (item.media_name.trim() === 'device'){
        return `digital screen`
      } else if (item.media_name.trim() === 'experience branding'){
        if (type.trim() === 'AM'){
          return `lightbox`
        }
        return `experience branding package`
      } else if (item.media_name.trim() === 'screen'){
        if (type.trim() === 'AM'){
          return `lcd`
        } 
        return `office`
      }
      return item.media_name
    },
    category_display(item){
      if (item.trim() === 'airport') {
        return `airport lounge`
      }
      return item
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>